
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nl/lemonade-goes-global",
      function () {
        return require("private-next-pages/nl/lemonade-goes-global.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nl/lemonade-goes-global"])
      });
    }
  